/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 获取次品组下的次品员和退供员 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Defective/getGroupMember`
 */
const postGetGroupMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Defective/getGroupMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGroupMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取次品组下的次品员和退供员 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Defective/getGroupMember`
 */
export const postGetGroupMember = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetGroupMemberRequestConfig, requestData),
    ...args
  );
};
postGetGroupMember.requestConfig = postGetGroupMemberRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 次品员列表 的 **请求配置**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Defective/getMembers`
 */
const postGetMembersRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Defective/getMembers",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMembers",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 次品员列表 的 **请求函数**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Defective/getMembers`
 */
export const postGetMembers = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetMembersRequestConfig, requestData), ...args);
};
postGetMembers.requestConfig = postGetMembersRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 分页 的 **请求配置**
 *
 * @分类 仓储API/次品组
 * @请求头 `POST /erp/Defective/getGroups`
 */
const postGetGroupsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Defective/getGroups",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGroups",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 分页 的 **请求函数**
 *
 * @分类 仓储API/次品组
 * @请求头 `POST /erp/Defective/getGroups`
 */
export const postGetGroups = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetGroupsRequestConfig, requestData), ...args);
};
postGetGroups.requestConfig = postGetGroupsRequestConfig;
/**
 * 接口 新增&编辑 的 **请求配置**
 *
 * @分类 仓储API/次品组
 * @请求头 `POST /erp/Defective/saveGroups`
 */
const postSaveGroupsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Defective/saveGroups",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveGroups",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新增&编辑 的 **请求函数**
 *
 * @分类 仓储API/次品组
 * @请求头 `POST /erp/Defective/saveGroups`
 */
export const postSaveGroups = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSaveGroupsRequestConfig, requestData), ...args);
};
postSaveGroups.requestConfig = postSaveGroupsRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/defective.js